import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ProduitForfaitComponent } from './pages/produitForfait/produitForfait.component';
import { ContactGeneralComponent } from './pages/contactGeneral/contactGeneral.component';
import { MentionsComponent } from './pages/terms/mentions.component';
import { NotFoundComponent } from './pages/notFound/notFound.component';
import { ProduitComponent } from './pages/produit/produit.component';
import { ProduitResolver } from './pages/produit/produit.resolver';
import { ColonnesResolver } from './pages/home/colonnes.resolver';
import { HPResolver } from './pages/home/hp.resolver';
import { PavesResolver } from './pages/home/paves.resolver';
import { OffresEmploiComponent } from './pages/offres-emploi/offres-emploi.component';
import { OffresEmploiResolver } from './pages/offres-emploi/offresEmploi.resolver';
import { OffreEmploiResolver } from './pages/offre-emploi/offreEmploi.resolver';
import { OffreEmploiComponent } from './pages/offre-emploi/offre-emploi.component';
import { CandidatureComponent } from './pages/candidature/candidature.component';
import { InstanceEtProduitResolver } from './pages/candidature/instanceEtProduit.resolver';
import { PostulerComponent } from './pages/postuler/postuler.component';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    resolve: {
     
    }
  },
  
  {
    path: 'postuler/:id_offre_emploi',
    component: PostulerComponent,
    resolve: {
      instanceEtProduit: InstanceEtProduitResolver,
    }
  },
  {
    path: 'candidature/:url_instance',
    component: CandidatureComponent,
    resolve: {
      instanceEtProduit: InstanceEtProduitResolver
    }
  },
  

  { path: ':url_instance',
    component: ProduitComponent,
    resolve: {
      produit: ProduitResolver
    }
  },

  { path: '**', redirectTo: 'page-introuvable'}
];

export const routing = RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',scrollPositionRestoration: 'enabled' 
});

export class AppRoutingModule { }
